import logo from "./logo.svg";
import "./App.css";
import ContactForm from "./ContactForm";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p style={{ fontSize: 30, fontWeight: "700", color: "#000" }}>
          Support Contact
        </p>
        <p
          style={{
            fontSize: 16,
            fontWeight: "700",
            marginTop: -20,
            color: "#000",
          }}
        >
          CryptGTN
        </p>
        <div style={{ minWidth: 350, maxWidth: 500, width: "100%" }}>
          <ContactForm />
        </div>
      </header>
    </div>
  );
}

export default App;
